import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import Ingredienti from "@/Ingredienti";

const IS_LIBRO = window.location.pathname.startsWith("/libro-degli-ingredienti");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {IS_LIBRO ? <Ingredienti /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);
